import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { DialogRef } from '@progress/kendo-angular-dialog';

import { TranslateService } from '@ngx-translate/core';

import { ContextService } from '@app/auth/context.service';

import { Customer, Area, Role } from '@app/shared/sdk/models';
import { AreaApi, RoleApi, CustomerApi } from '@app/shared/sdk/services';

@Component({
  selector: 'customer-form',
  templateUrl: './customer-form.component.html',
  styleUrls: ['./customer-form.component.css']
})
export class CustomerFormComponent {
  @Input() public set model(customer: Customer) {
    // this.customer = customer;
    
   // Asignar valores por defecto si no vienen definidos
   this.customer = {
    firstName: customer.firstName || '',
    lastName: customer.lastName || '',
    username: customer.username || '',
    password: customer.password || '',
    email: customer.email || '',
    telephone: customer.telephone || '',
    workerCode: customer.workerCode || '',
    category: customer.category || '',
    language: customer.language || 'es',
    memory: customer.memory || 'A',
    defaultAreaId: customer.defaultAreaId || '64567781fc4301bfeab2dd59',
    active: customer.active !== undefined ? customer.active : true,
    createdBy: customer.createdBy || 'system',
    createdAt: customer.createdAt || new Date().toISOString(),
    updatedBy: customer.updatedBy || 'system',
    updatedAt: customer.updatedAt || new Date().toISOString(),
    realm: customer.realm || null,
    emailVerified: customer.emailVerified || null,
    id: customer.id || null,
    roles: [], // lo sobreescribimos abajo
    ...customer // asegura que cualquier otro campo no mencionado explícitamente se mantenga
  };

  // Asignar el rol fijo 'service'
  const serviceRole: Role = new Role({
    id: 1, // ID real del rol "service"
    name: 'service',
    description: 'Service',
    created: new Date(),
    modified: new Date(),
    principals: []
  });

  this.customer.roles = [serviceRole];

  // Resetear el formulario con datos completos
  this.customerFormGroup.reset(this.customer);

  // Asignar rol en el formulario
  this.customerFormGroup.get('role').setValue(serviceRole);

  // Quitar validación obligatoria del token si no aplica
  this.customerFormGroup.get('accessToken').clearValidators();
  this.customerFormGroup.get('accessToken').updateValueAndValidity();

  // Asignar áreas por defecto
  this.customerFormGroup.get('areas').setValue([1]);  // O un objeto válido
  this.customerFormGroup.get('defaultArea').setValue(1);

    // set password validtor for adding and editing
    /*if (customer.username == undefined)
      this.customerFormGroup.get('password').setValidators([Validators.required, Validators.maxLength(250)]);
    else
      this.customerFormGroup.get('password').setValidators([Validators.maxLength(250)]);*/

    // set role item from collection
    // if (customer.roles.length > 0) {
    //   this.customerFormGroup.get('role').setValue(customer.roles[0]);

    //   // show access token for service user role
    //   this.onRoleChange(customer.roles[0]);

    //   if (customer.roles[0].name == 'service') {
    //     this.customerApi.getAccessTokens(customer.id).subscribe((accessTokens: any) => {
    //       if(accessTokens.length > 0)
    //         this.customerFormGroup.get('accessToken').setValue(accessTokens[0].id);
    //     },
    //     err => {
    //         console.log(err);
    //     });
    //   }
    // }
 
  }

  public customer: Customer;
  public areas: Area[];
  public roles: Role[];
  public accessToken: string;
  public isRoleService = false;
  public languages: Array<{ text: string, value: string }> = [
    { text: this.translate.instant("CUSTOMER_FORM.SPANISH"), value: 'es' },
    { text: this.translate.instant("CUSTOMER_FORM.ENGLISH"), value: 'en' }
  ];

  public customerFormGroup = this.fb.group({
    id: [],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    workerCode: [''],
    category: [''],
    language: ['', Validators.required],
    memory: ['', Validators.required],
    telephone: ['', Validators.maxLength(20)],
    email: Validators.compose([Validators.email, Validators.maxLength(250)]),
    username: ['', Validators.compose([Validators.maxLength(250)])],
    password: ['', Validators.compose([Validators.maxLength(250)])],
    accessToken: [''],
    roles: [''],
    role: ['', Validators.required],
    areas: ['', Validators.required],
    defaultArea: ['', Validators.required],
    active: [true],
    createdBy: [''],
    createdAt: [''],
    updatedBy: [''],
    updatedAt: ['']
  });

  constructor(private translate: TranslateService,
              private fb: FormBuilder,
              private dialog: DialogRef,
              private areaApi: AreaApi,
              private roleApi: RoleApi,
              private customerApi: CustomerApi) {
      // this.getRoles();
      // this.getAreas();
  }

  // private getRoles() {
  //   this.roleApi.find().subscribe((roles: any) => {
  //     this.roles = roles;
  //   },
  //   err => {
  //       console.log(err);
  //   });
  // }

  // private getAreas() {
  //   this.areaApi.find({"include": [{"relation": "site", "include": [{"relation": "organization", "scope": {"where": {"id": ContextService.context.area.site.organization.id }}}]}]}).subscribe((areas: any) => {
  //     this.areas = areas;
  //   },
  //   err => {
  //       console.log(err);
  //   });
  // }

  // public onRoleChange(role) {
  //     console.log("roleChange : ", role);

  //     if (role.name == 'service') {
  //       this.isRoleService = true;
  //       this.customerFormGroup.get('accessToken').setValidators([Validators.required]);
  //     }
  //     else {
  //       this.isRoleService = false;
  //       this.customerFormGroup.get('accessToken').setValidators([]);
  //     }
  // }

  // public onAccessToken(event): void {
  //   this.customerApi.createAccessToken().subscribe((accessToken: any) => {
  //     this.customerFormGroup.get('accessToken').setValue(accessToken);
  //   },
  //   err => {
  //       console.log(err);
  //   });
  // }

  private closeForm(event): void {
    this.dialog.close();
  }

  public onSave(event): void {
    event.preventDefault();

    // add role user to roles collection before save
    this.customerFormGroup.get('roles').setValue([]);
    this.customerFormGroup.get('roles').value.push(this.customerFormGroup.get('role').value);

    const customerData = { ...this.customerFormGroup.value };

  // Eliminar propiedades que el backend no acepta
  delete customerData.areas;
  delete customerData.defaultArea;
  delete customerData.roles;
  // Convertir nulls a string vacíos donde corresponda
  ['id', 'telephone', 'workerCode', 'category'].forEach(key => {
    if (customerData[key] === null) customerData[key] = '';
  });

  // Enviar los datos limpios
  this.dialog.close(customerData);
}

  public onCancel(event): void {
    event.preventDefault();

    this.closeForm(event);
  }
}





// import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
// import { Validators, FormBuilder } from '@angular/forms';
// import { DialogRef } from '@progress/kendo-angular-dialog';

// import { TranslateService } from '@ngx-translate/core';

// import { ContextService } from '@app/auth/context.service';

// import { Customer, Area, Role } from '@app/shared/sdk/models';
// import { AreaApi, RoleApi, CustomerApi } from '@app/shared/sdk/services';

// @Component({
//   selector: 'customer-form',
//   templateUrl: './customer-form.component.html',
//   styleUrls: ['./customer-form.component.css']
// })
// export class CustomerFormComponent {
//   @Input() public set model(customer: Customer) {
//     this.customer = customer;
//     this.customerFormGroup.reset(customer);

//     // set password validtor for adding and editing
//     /*if (customer.username == undefined)
//       this.customerFormGroup.get('password').setValidators([Validators.required, Validators.maxLength(250)]);
//     else
//       this.customerFormGroup.get('password').setValidators([Validators.maxLength(250)]);*/

//     // set role item from collection
//     if (customer.roles.length > 0) {
//       this.customerFormGroup.get('role').setValue(customer.roles[0]);

//       // show access token for service user role
//       this.onRoleChange(customer.roles[0]);
      
//       if (customer.roles[0].name == 'service' ) {
//         this.customerApi.getAccessTokens(customer.id).subscribe((accessTokens: any) => {
//           if(accessTokens.length > 0)
//             this.customerFormGroup.get('accessToken').setValue(accessTokens[0].id);
//         },
//         err => {
//             console.log(err);
//         });
//       }
//     }
//   }

//   public customer: Customer;
//   public areas: Area[];
//   public roles: Role[];
//   public accessToken: string;
//   public isRoleService = false;
//   public languages: Array<{ text: string, value: string }> = [
//     { text: this.translate.instant("CUSTOMER_FORM.SPANISH"), value: 'es' },
//     { text: this.translate.instant("CUSTOMER_FORM.ENGLISH"), value: 'en' }
//   ];

//   public customerFormGroup = this.fb.group({
//     id: [],
//     firstName: ['', Validators.required],
//     lastName: ['', Validators.required],
//     workerCode: [''],
//     category: [''],
//     language: ['', Validators.required],
//     memory: ['', Validators.required],
//     telephone: ['', Validators.maxLength(20)],
//     email: Validators.compose([Validators.email, Validators.maxLength(250)]),
//     username: ['', Validators.compose([Validators.maxLength(250)])],
//     password: ['', Validators.compose([Validators.maxLength(250)])],
//     accessToken: [''],
//     roles: [''],
//     role: ['', Validators.required],
//     areas: ['', Validators.required],
//     defaultArea: ['', Validators.required],
//     active: [true],
//     createdBy: [''],
//     createdAt: [''],
//     updatedBy: [''],
//     updatedAt: ['']
//   });

//   constructor(private translate: TranslateService,
//               private fb: FormBuilder,
//               private dialog: DialogRef,
//               private areaApi: AreaApi,
//               private roleApi: RoleApi,
//               private customerApi: CustomerApi) {
//       this.getRoles();
//       this.getAreas();
//   }

//   private getRoles() {
//     this.roleApi.find().subscribe((roles: any) => {
//       this.roles = roles;
//     },
//     err => {
//         console.log(err);
//     });
//   }

//   private getAreas() {
//     this.areaApi.find({"include": [{"relation": "site", "include": [{"relation": "organization", "scope": {"where": {"id": ContextService.context.area.site.organization.id }}}]}]}).subscribe((areas: any) => {
//       this.areas = areas;
//     },
//     err => {
//         console.log(err);
//     });
//   }

//   public onRoleChange(role) {
//       console.log("roleChange : ", role);

//       if (role.name == 'service') {
//         this.isRoleService = true;
//         this.customerFormGroup.get('accessToken').setValidators([Validators.required]);
//       }
//       else {
//         this.isRoleService = false;
//         this.customerFormGroup.get('accessToken').setValidators([]);
//       }
//   }

//   public onAccessToken(event): void {
//     this.customerApi.createAccessToken().subscribe((accessToken: any) => {
//       this.customerFormGroup.get('accessToken').setValue(accessToken);
//     },
//     err => {
//         console.log(err);
//     });
//   }

//   private closeForm(event): void {
//     this.dialog.close();
//   }

//   public onSave(event): void {
//     event.preventDefault();

//     // add role user to roles collection before save
//     this.customerFormGroup.get('roles').setValue([]);
//     this.customerFormGroup.get('roles').value.push(this.customerFormGroup.get('role').value);

//     // return entity state
//     this.dialog.close(this.customerFormGroup.value);
//   }

//   public onCancel(event): void {
//     event.preventDefault();

//     this.closeForm(event);
//   }
// }
